import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

interface Props {
  organizationName: string;
  hasNoEvents?: boolean;
}

export function OrgCard({
  organizationName,
  children,
  hasNoEvents,
}: PropsWithChildren<Props>) {
  return (
    <div className={classNames("flex flex-col gap-4 bg-background", {
      'w-full max-w-4xl': !hasNoEvents,
    })}>
      <div className="flex flex-col gap-1">
        <h1 className="text-3xl md:text-4xl font-bold">{organizationName}</h1>
        <h2 className="text-base md:text-lg text-muted-foreground">
          Upcoming events for {organizationName}
        </h2>
      </div>
      <div className="flex flex-col gap-8">{children}</div>
    </div>
  );
}
